module.exports = "/_next/static/images/banner_yellowpick_585.XsSoZZh6.png";